import { useEffect, useRef } from "react";

export default function useClickOutside<T extends HTMLElement>(callback: () => void) {
    const ref = useRef<T>(null);

    useEffect(() => {
        const handleClick = (event: MouseEvent | TouchEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback();
            }
        };

        document.addEventListener('click', handleClick, true);
        document.addEventListener('touchend', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
            document.removeEventListener('touchend', handleClick, true);
        };
    }, [callback]);

    return ref;
};